export const UPDATE_SHIPMENT_REQUESTED = 'UPDATE_SHIPMENT_REQUESTED';
export const UPDATE_SHIPMENT_SUCCEEDED = 'UPDATE_SHIPMENT_SUCCEEDED';
export const DELETE_SHIPMENT_REQUESTED = 'DELETE_SHIPMENT_REQUESTED';
export const DELETE_SHIPMENT_SUCCEEDED = 'DELETE_SHIPMENT_SUCCEEDED';
export const DOWNLOAD_INVOICE_REQUESTED = 'DOWNLOAD_INVOICE_REQUESTED';
export const DOWNLOAD_INVOICE_SUCCEEDED = 'DOWNLOAD_PDF_SUCCEEDED';
export const REGENERATE_INVOICE_REQUESTED = 'REGENERATE_INVOICE_REQUESTED';
export const REGENERATE_INVOICE_SUCCEEDED = 'REGENERATE_INVOICE_SUCCEEDED';
export const RETURN_ORDER_PRODUCT_ITEM_SUCCESSED = 'RETURN_ORDER_PRODUCT_ITEM_SUCCESSED';
export const RETURN_ORDER_PRODUCT_ITEM_REQUESTED = 'RETURN_ORDER_PRODUCT_ITEM_REQUESTED';

export const CONFIRM_RETURN_ORDER_PRODUCT_ITEM_SUCCESSED = 'CONFIRM_RETURN_ORDER_PRODUCT_ITEM_SUCCESSED';
export const CONFIRM_RETURN_ORDER_PRODUCT_ITEM_REQUESTED = 'CONFIRM_RETURN_ORDER_PRODUCT_ITEM_REQUESTED';

export const CANCEL_SHIPMENT_PRODUCT_REQUESTED = 'CANCEL_SHIPMENT_PRODUCT_REQUESTED';
export const CANCEL_SHIPMENT_PRODUCT_SUCCEEDED = 'CANCEL_SHIPMENT_PRODUCT_SUCCEEDED';
export const POPULATE_CONFIRM_SHIPMENT_REQUESTED = 'POPULATE_CONFIRM_SHIPMENT_REQUESTED';
export const SEND_SHIPMENT_TO_ACCOUNTING_REQUESTED = 'SEND_SHIPMENT_TO_ACCOUNTING_REQUESTED';
export const SET_SHIPMENT_AS_PRINTED_REQUESTED = 'SET_SHIPMENT_AS_PRINTED_REQUESTED';
export const SET_SHIPMENT_AS_PRINTED_SUCCEEDED = 'SET_SHIPMENT_AS_PRINTED_SUCCEEDED';
export const FETCH_SHIPMENT_DETAIL_REQUESTED = 'FETCH_SHIPMENT_DETAIL_REQUESTED';
export const FETCH_SHIPMENT_DETAIL_SUCCESSED = 'FETCH_SHIPMENT_DETAIL_SUCCESSED';
